import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PersonStateFalseNotiFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PersonStateFalseNotiFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.0003 12.9521C8.97139 12.9521 6.5068 10.5177 6.5068 7.52537C6.5068 4.53405 8.97138 2.09961 12.0003 2.09961C15.0291 2.09961 17.4937 4.53404 17.4937 7.52537C17.4937 10.5177 15.0291 12.9521 12.0003 12.9521ZM12.0003 3.60557C9.81161 3.60557 8.03141 5.3635 8.03141 7.52537C8.03141 9.68724 9.8116 11.4461 12.0003 11.4461C14.1889 11.4461 15.9691 9.68724 15.9691 7.52537C15.9691 5.3635 14.1889 3.60557 12.0003 3.60557Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.2377 22.0996C19.8168 22.0996 19.4754 21.7623 19.4754 21.3466V18.5308C19.4754 17.0915 18.2902 15.9209 16.8331 15.9209H7.16736C5.71025 15.9209 4.52461 17.0915 4.52461 18.5308V21.3466C4.52461 21.7623 4.18316 22.0996 3.7623 22.0996C3.34145 22.0996 3 21.7623 3 21.3466V18.5308C3 16.2611 4.86953 14.4149 7.16736 14.4149H16.8331C19.131 14.4149 21 16.2611 21 18.5308V21.3466C21 21.7623 20.6585 22.0996 20.2377 22.0996Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PersonStateFalseNotiFalseIcon;
